import React from 'react';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';

function MaskedInputComponent({mask, onChange, value, children}) {
    return <InputMask
        mask={mask}
        onChange={onChange}
        value={value}
    >
        {children}
    </InputMask>;
}

MaskedInputComponent.propTypes = {
    mask: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.any
};

export default MaskedInputComponent;
